import { render, staticRenderFns } from "./CheckGoodsCard.vue?vue&type=template&id=018c3285&scoped=true"
import script from "./CheckGoodsCard.vue?vue&type=script&lang=js"
export * from "./CheckGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./CheckGoodsCard.vue?vue&type=style&index=0&id=018c3285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c3285",
  null
  
)

export default component.exports